import { render, staticRenderFns } from "./YwArtificialPatrolTaskDetailForm copy.vue?vue&type=template&id=7c4f6ce6&"
import script from "./YwArtificialPatrolTaskDetailForm copy.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolTaskDetailForm copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports